
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career/[slug]",
      function () {
        return require("private-next-pages/career/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career/[slug]"])
      });
    }
  